import React from 'react';
import Image from "../../components/Image/Image";
import './404.scss';
import storage from "../../utils/storage";

class NotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    goPage (url) {
        if (window.historyInstance) {
            window.historyInstance.replace(url)
        } else {
            window.location.href = url;
        }
    }

    render() {
        const token = storage.getItem('token');
        return (
            <div className="notFoundFrame">
                <Image iClassName="notFoundImg" imgSrc={require("../../assets/img/notFound.png")}></Image>
                <span className="tipText">您访问的页面不存在</span>
                <span className="backBtn" onClick={() => this.goPage('/page/book-list')}>去首页</span>
            </div>
        );
    }
}

NotFound.propTypes = {};

export default NotFound;
